import classNames from 'classnames';
import { motion } from 'framer-motion';
import React from 'react';
import styles from './Badge.module.scss';

interface Props {
  circle?: boolean;
  className?: string;
  variant?: 'success' | 'danger' | 'warning' | 'primary';
  size?: 'xxsmall' | 'xsmall' | 'small' | 'medium';
  position?: 'topLeft' | 'topRight';
  children?: React.ReactNode;
  /** If true, a spring animation will be displayed on mount. */
  animated?: boolean;
}

const Badge = (props: Props) => {
  const {
    variant = 'success',
    size = 'medium',
    circle = true,
    position,
    className,
    children,
    animated: animate,
  } = props;
  const finalClassName = classNames(
    styles.container,
    styles[`variant-${variant}`],
    styles[position ?? ''],
    styles[`size-${size}`],
    className,
    {
      [styles.circle]: circle,
    }
  );

  return animate ? (
    <motion.div
      className={finalClassName}
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1, type: 'spring' }}
      style={{ originX: 0.72, originY: 0.24 }}
    >
      {children}
    </motion.div>
  ) : (
    <div className={finalClassName}>{children}</div>
  );
};

export default Badge;
